import React, { useMemo } from 'react';
import { Moment } from "moment";
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { CompanyHolidayOverview } from '@features/holidays/services/CompanyHolidayService';
import { CompanyHolidayItem } from "./CompanyHolidayItem";
import { useTranslation } from "react-i18next";
import { naturalSort } from '@shared/utils/ArrayUtils';

export function CompanyHolidaysList(props: Props) {
  const {companyHolidays, disabled} = props;
  const {t} = useTranslation();
  const sortedHolidayList = useMemo(() => {
    return naturalSort(companyHolidays?.companyHolidays ?? [], 'date');
  }, [companyHolidays])

  return (
    <Container>
      {companyHolidays ? <>
        <BodyRegular weight={600} color={Colours.mildGrey}>{t('company-holiday.number-of-holidays')}</BodyRegular>
        <HeadlineMedium style={{marginBottom: 24}}>{companyHolidays.totalCompanyHolidays}</HeadlineMedium>
        {!disabled && <PrimaryButton text={"button.add-company-holiday"}
                                    link={'/manage/company-holidays/add'}
                                    style={{marginBottom: 32}}
                                    disabled={disabled}
                                    fullWidth={true} />}

        {sortedHolidayList.map((holiday, key) => (
          <CompanyHolidayItem companyHoliday={holiday} key={key} disabled={disabled} />
        ))}

      </> : <></>}
    </Container>
  )
}

interface Props {
  activeDate: Moment;
  companyHolidays?: CompanyHolidayOverview;
  disabled: boolean;
}

const Container = styled.div`
  border: 1px solid ${Colours.mildGrey};
  border-radius: 24px;
  padding: 32px;
`
